module.exports = __webpack_public_path__ + "img/gb1337.prt.267b000d.jpg";